export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bethappy-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bethappy-themeWrapLive" */'./LiveThemeImporter'),
  },
};
